require('./angular-idle');
module.exports = 'ngIdle';



//////////////////
// WEBPACK FOOTER
// ./~/ng-idle/index.js
// module id = 418
// module chunks = 37